import * as React from "react";

export const BatterySelectionStep = () => {
    return <div>
        <h1>BatterySelectionStep </h1>
    </div>
};